import React from "react";
import {
  EllipsisVerticalIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/24/outline";

const GlobalTableDropDown = ({
  data,
  showMenu,
  callBack,
  setShowMenu,
  isLastIndex,
  menuItems,
  handleDropDownMenu,
}) => {
  return (
    <div className="w-[18px] relative">
      <div className="">
        {showMenu ? (
          <EllipsisHorizontalIcon
            className="w-[18px] h-[18px] text-[#A7AFB7] cursor-pointer"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation();
              callBack(data, true);
            }}
          />
        ) : (
          <EllipsisVerticalIcon
            className="w-[18px] h-[18px] text-[#A7AFB7] cursor-pointer"
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation();
              callBack(data, false);
            }}
          />
        )}
      </div>
      <div
        className={`${
          showMenu ? "block" : "hidden"
        } global-dropdown min-w-[130px] border border-[#EBEFF3] rounded-[10px] shadow-md p-5 absolute right-1 top-6 bg-white z-10 ${
          isLastIndex && "second-last-dropdown"
        }`}
      >
        <ul className="global-dropdown-list">
          {menuItems &&
            menuItems.map((item, index) => (
              <li
                key={index}
                className="flex items-center gap-2.5 mb-2.5 pb-2.5 border-b border-[#EBEFF3] text-customGray cursor-pointer"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation();
                  setShowMenu && setShowMenu(false)
                  handleDropDownMenu && handleDropDownMenu(item.value, data);
                }}
              >
                <item.icon className="w-5 h-5" />
                <span className="text-sm font-medium leading-[160%] inline-block">
                  {item.label}
                </span>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default GlobalTableDropDown;
